import { useEffect, useRef } from 'react';

export const useWakeLock = () => {
	const wakeLock = useRef<WakeLockSentinel | null>(null);

	const isSupported = navigator.wakeLock !== undefined;

	useEffect(() => {
		if (!isSupported) return;

		let active = true;

		const request = async () => {
			try {
				// console.log('request wakeLock');
				const ws = await navigator.wakeLock.request('screen');
				if (!active) {
					// component unmounted before lock acquired
					await ws.release();
					return;
				}
				ws.onrelease = () => {
					// console.log('wakeLock released');
					wakeLock.current = null;
				};

				wakeLock.current = ws;
			} catch (e) {
				console.warn('wakeLock failed', e);
			}
		};
		request();

		const handleVisibilityChange = async () => {
			if (wakeLock.current === null && document.visibilityState === 'visible') {
				// console.log('request wakeLock on visibilitychange');
				request();
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			// console.log('wakeLock cleanup');
			active = false;
			document.removeEventListener('visibilitychange', handleVisibilityChange);
			if (wakeLock.current) {
				// console.log('release wakeLock');
				wakeLock.current.release();
				wakeLock.current = null;
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		active: wakeLock.current !== null,
		isSupported,
	};
};
